module.exports = __webpack_public_path__ + "img/plus.236ac72d.svg";